<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="onUpdateFilters"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="128" v-if="userId === null">
          <v-container fluid>
            <v-row class="mt-10">
                <v-text-field
                    v-model="searchTerm"
                    label="Search user"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="startMonth" clearable label="From" @input="onUpdateFilters"></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="endMonth" clearable label="To" @input="onUpdateFilters"></v-text-field>
            </v-row>
          </v-container>
        </v-toolbar>

      </template>
      <template v-slot:item.error="{ item }">
          <v-simple-checkbox :value="item.error"></v-simple-checkbox>
      </template>
      <template v-slot:item.human_user__employee_number="{ item }">
        <span v-if="item.human_user != null">{{ item.human_user.user }} ({{ item.human_user.employee_number }})</span>
      </template>
      <template v-slot:item.calendar_date__dt="{ item }">
        <span v-if="item.calendar_date">{{ item.calendar_date.dt | moment("DD.MM.YYYY") }}</span>
      </template>
      <template v-slot:item.work="{ item }">
        {{ getDuration(item.work) }}
      </template>
      <template v-slot:item.pause="{ item }">
        {{ getDuration(item.pause) }}
      </template>
    </v-data-table>
    <TimeTrackerConfirmDialog></TimeTrackerConfirmDialog>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEnterEvent from "@/components/TimeTracker/TimeTrackerEnterEvent";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import TimeTrackerNewDialogTime from "@/components/TimeTracker/TimeTrackerNewDialogTime";
import TimeTrackerNewDialogRange from "@/components/TimeTracker/TimeTrackerNewDialogRange";
import TimeTrackerConfirmDialog from "@/components/TimeTracker/TimeTrackerConfirmDialog";


export default {
  name: 'ContractExecution',
  props: {
    subtractHeight: {type: [Number], default: 290},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    date: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserErrorDTO'},
    errorInit: {type: [Boolean], default: null},
  },

  components: {
    TimeTrackerEnterEvent,
    BaseDeleteDialog,
    TimeTrackerNewDialogTime,
    TimeTrackerNewDialogRange,
    TimeTrackerConfirmDialog,
  },

  computed: {
    ...mapGetters('CalendarDateUser', ['getColumns']),
    ...mapFields('CalendarDateUser', ['message_error', 'totalRecords', 'onlyFailedView', 'briefView', 'itemList',
      'options', 'options.page',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
  },

  methods: {
    ...mapActions('CalendarDateUser', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      // if (item.error)
      //   return "error_flag"
    },

    // updateOptions() {
    //   // console.log('updateOptions ContractExecution', this.userId)
    //   this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    // },

    onUpdateFilters() {
      // console.log('updateOptions ContractExecution', this.userId, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      // this.filters['only_error'] = this.only_error
      if (this.userId !== null)
        this.filters['user_id'] = this.userId
      else
        this.filters['user_id'] = null

      if (this.startMonth && this.userId === null) {
        this.filters['from_date'] = this.startMonth + " 00:00:00"
      }
      else
        this.filters['from_date'] = null

      if (this.endMonth && this.userId === null) {
        this.filters['to_date'] = this.endMonth + " 23:59:59"
      }
      else
        this.filters['to_date'] = null

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),
    getDuration(duration_hours) {
      let abs_duration_hours = Math.abs(duration_hours)
      let hours = Math.floor(abs_duration_hours)
      let minutes = Math.floor(abs_duration_hours * 60) % 60
      if (!duration_hours)
        return '00:00'
      if (duration_hours >= 0)
        return ' ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
      else
        return '-' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    this.searchTerm = null
    this.endMonth = new Date().toISOString().slice(0, 10)

  },

  data() {
    return {
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      startMonth: null,
      endMonth: null,
      only_error: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.error_flag {
  background-color: #FFEBEE !important;
}

</style>
